import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/blue.png";
import fruit from "/cywe-assets/fruit/fig.png";

export default function Blue({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="The Peace of God surpasses your understanding!"
				description="Being in harmony and a state of understanding and tranquility with the world and with yourself, always being able to find the calm after the storm and having hope for the future ahead."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/6"
				next="/experience/8"
			/>
		</>
	);
}
